module.exports = __webpack_public_path__ + "img/iconMFS.3fa850b1.svg";